import React from 'react';

import Layout from '~/components/layout';
import { SEO } from '~/components/seo';
import { PrivacyPolicy } from '~/components/privacy_policy';

const PrivacyPolicyPage: React.FC = () => (
  <Layout>
    <SEO
      title="プライバシーポリシー"
      description="株式会社Re rootsのプライバシーポリシーについてご案内しています。"
    />
    <PrivacyPolicy />
  </Layout>
);

export default PrivacyPolicyPage;
